import { CssBaseline, ThemeProvider } from '@mui/material';
import { ErrorBoundary } from '@sentry/react';
import CdkSessionGuard from 'app/auth/CdkSessionGuard';
import SessionTimeoutGuard from 'app/auth/SessionTimeoutGuard';
import SsoAccountVerificationGate from 'app/auth/SsoAccountVerificationGate';
import Error500Page from 'app/pages/misc/Error500Page';
import AuthProvider from 'app/shared-components/auth/AuthProvider';
import SharedDialog from 'app/shared-components/layout/SharedDialog';
import { SnackbarUtilsConfigurator } from 'app/shared-components/util/SnackbarUtils';
import theme from 'app/theme';
import { SnackbarProvider } from 'notistack';
import { BrowserRouter } from 'react-router-dom';
import { DeviceProvider } from './shared-components/device/DeviceProvider';
import { SidesheetProvider } from './shared-components/sidesheets/SidesheetProvider';
import withAppProviders from './withAppProviders';

const App = () => {
  return (
    <AuthProvider>
      {/* <SpeedchatProvider> */}

      <ThemeProvider theme={theme}>
        <CssBaseline />
        <SnackbarProvider
          maxSnack={5}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <SnackbarUtilsConfigurator />
          <SidesheetProvider>
            <BrowserRouter>
              <ErrorBoundary fallback={Error500Page} showDialog>
                <DeviceProvider>
                  <SharedDialog />
                  <SessionTimeoutGuard />
                  <CdkSessionGuard />
                  <SsoAccountVerificationGate />
                </DeviceProvider>
              </ErrorBoundary>
            </BrowserRouter>
          </SidesheetProvider>
        </SnackbarProvider>
      </ThemeProvider>

      {/* </SpeedchatProvider> */}
    </AuthProvider>
  );
};

export default withAppProviders(App)();
